import React from 'react'
import {isEmpty} from 'lodash'
import {Redirect} from 'react-router-dom'

import errors from '../../lib/errors.js'
import ClientCard from './ClientCard'
import ClientNotFound from './ClientNotFound'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'

import Resource from '../../stores/resource'
const ClientStore = Resource('clients')


class ShowClientPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      client: {},
      error: null,
      loading: true
    }
  }

  componentDidMount() {
    ClientStore.find(this.props.match.params.id)
    .then((result) => this.setState({client: result.data, loading: false}))
    .catch((error) => this.setState({client: {}, error: errors.unpack(error), loading: false}))
  }

  _redirectTo = (url) => {
    this.setState({redirect: url})
  }

  render() {
    const {
      client,
      redirect,
      loading
    } = this.state

    if (loading) return <LinearLoader />
    if (redirect) return <Redirect push to={redirect}/>
    if (isEmpty(client)) return <ClientNotFound/>

    return (
      <section>
        <header>
          <PageTitle>
            Client
          </PageTitle>
        </header>
        <ClientCard
          client={client}
          editCallback={() => this._redirectTo(`/clients/${client.id}/edit`)}
        />
        <br/>
        <BackButton/>
      </section>
    )
  }
}

export default ShowClientPage



// WEBPACK FOOTER //
// ./src/components/Clients/ShowClientPage.jsx